import classNames from "classnames";
import DownloadInfoTableExcel from "components/DownloadInfoTableExcel";
import SaveAsCollection from "components/SaveAsCollection";
import SaveCollection from "components/SaveCollection";
import UnassignFromCollection from "components/UnassignFromCollection";
import DropDownAddCollection from "components/uiComponents/DropDownAddCollection";
import SearchInput from "components/uiComponents/SearchInput";
import UniversalButton from "components/uiComponents/UniversalButton";
import { ReactComponent as FunctionIcon } from "../../static/icons/function.svg";
import { tabType } from "utils/data";
import { useCallback, useMemo } from "react";

export const ViewTableLayout = ({
  headerComponent,
  footerComponent,
  rowsComponent,
  searchValue,
  setSearchValue,
  table,
  deleteSelectElements,
  totalColumnsValue,
  tableHeaders,
  onShowConditionModal,
  selectedItems,
  dataForDownloadTable,
}) => {
  const getTableDataForSelectedElements = () => {
    const lineElements = Object.values(selectedItems);

    return {
      ...table,
      lineElements,
      deleteCollection: lineElements.length === table.lineElements.length,
    };
  };

  const isSelectItems = useMemo(() => {
    return !!Object.keys(selectedItems).length;
  }, [selectedItems]);

  const fileName = useMemo(() => {
   return table.folder ? `${table.folder} - ${table.name}` : "BIMSearch report";
  }, [table])

  const handleChangeText = useCallback((event) => {
    setSearchValue(event.target.value)
  }, [setSearchValue])

  const clearText = useCallback(() => {
    setSearchValue('')
  }, [setSearchValue])

  return (
    <div className="dashboard-info-table">
      <div className="dashboard-info-table__buttons">
        <div className="dashboard-info-table__buttons_search">
          <SearchInput
            size="md"
            type="text"
            name="sideSearch"
            className="find"
            placeholder="Search..."
            width={250}
            value={searchValue}
            isVisible
            onChange={handleChangeText}
            onHideSearch={clearText}
          />
        </div>
        <div className="dashboard-info-table__buttons-right">

          {table.type === tabType.unsaved && !isSelectItems ? (
            <SaveCollection tableInfo={table} />
          ): null }

          {isSelectItems && table.type !== tabType.report ? (
            <UnassignFromCollection
              deleteSelectElements={deleteSelectElements}
              tableInfo={getTableDataForSelectedElements()}
            />
          ) : null}

          {isSelectItems ? (
            <SaveAsCollection tableInfo={getTableDataForSelectedElements()} />
          ) : null}

          {isSelectItems ? (
            <DropDownAddCollection tableInfo={getTableDataForSelectedElements()} />
          ) : null}

          {!!tableHeaders && !!dataForDownloadTable && !!totalColumnsValue ? (
            <DownloadInfoTableExcel
              header={tableHeaders}
              lines={dataForDownloadTable.map((el) => el.lines)}
              fileName={fileName}
              totals={totalColumnsValue}
              isCheckFlag={isSelectItems}
            />
          ) : null}

          <UniversalButton
            type="button"
            label="Add custom column"
            leftIcon={<FunctionIcon />}
            size="md"
            isRounded="sm"
            labelColor="blue"
            labelHoverColor="blue"
            backgroundColor="blue"
            backgroundHoverColor="blue-light"
            onClick={onShowConditionModal}
          />
        </div>
      </div>
      <div
        className={classNames({
          "dashboard-info-table__container": true,
        })}
      >
        <div className="table">
          {headerComponent}

          {rowsComponent}

          {footerComponent}
        </div>
      </div>
    </div>
  );
};
